import {html, PolymerElement} from "@polymer/polymer/polymer-element.js";
import "@cbar/cbar-shared-styles/cbar-shared-styles.js";
import "@polymer/paper-input/paper-input.js";
import "@polymer/paper-button/paper-button.js";
import "@polymer/iron-image/iron-image.js";
import "@cbar/cbar-photo-preview/cbar-photo-preview.js";
import "@polymer/paper-icon-button/paper-icon-button";
import "@polymer/iron-icons/image-icons.js";
import "@polymer/iron-icons/editor-icons.js";
import "@cbar/cbar-photo-uploader/cbar-photo-uploader.js";
import '@polymer/paper-spinner/paper-spinner.js';

import dayjs from 'dayjs/esm';

/**
 * `cbar-chat-client`
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarChatClient extends PolymerElement {
  static get template() {
    // language=HTML
    return html`
        <style include="cbar-shared-styles" xmlns="http://www.w3.org/1999/html">
            :host {
                display: flex;
                flex-direction: column;
                height: 100%;
            }

            :host([fixed]) .message-section{
                position: fixed;
                bottom: 0;
                left: 0;
                right: 0;
                padding-bottom: 32px;
            }

            paper-card {
                margin: 10px 0;
                width: 100%;
            }

            #wrapper {
                overflow-y: scroll;
                flex: 1;
                padding-bottom: 64px
            }

            :host([fixed]) #wrapper{
                padding-bottom: 72px;
                padding-top: 8px;
            }

            #button-div {
                display: flex;
                justify-content: flex-end;
            }

            .message-card {
                background-color: var(--cbar-chat-client-message-background, #e4e4e4);
                color: var(--cbar-sys-color-on-surface, black);
            }

            .typing-div {
                padding: 16px;
                font-family: Roboto, noto, sans-serif;
                font-size: 14px;
                font-weight: normal;
            }

            .message-section {
                /* background-color: #e8e8e8; */
                padding: 10px;
                margin-top: 5px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: var(--cbar-chat-client-message-background, #e4e4e4);
                color: var(--cbar-sys-color-on-surface, black);
            }

            .card-content {
                padding: 8px;
                width: 100%;
                display: flex;
                flex-direction: column;
                max-width: 100%;
                word-break: break-word;
                box-sizing: border-box;
            }

            .row {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            .message-content {
                /* offset for top section */
                margin-left: 40px;
            }

            .time-display {
                opacity: 0.6;
            }

            iron-image {
                height: 200px;
                width: 100%;
                cursor: pointer;
            }

            iron-image.message-content {
                width: calc(100% - 66px);
            }

            input{
                cursor: pointer;
            }
            input[disabled]{
                cursor: default;
            }

            .avatar {
                margin-top: 0;
                cursor: default;
                height: 24px;
                width: 24px;
                border-radius: 50%;
                margin-right: 16px;
            }

            paper-button[disabled] {
                background: darkgrey !important;
            }

            paper-icon-button {
                color: grey;
            }

            paper-icon-button[disabled] {
                color: #e4e4e4;
            }

            paper-input {
                flex: 1;
                --paper-input-container-input: {
                    font-size: 14px;
                };
                --paper-input-container-label: {
                    font-size: 14px;
                };
                --paper-input-container-underline: {
                    display: none;
                };
                --paper-input-container-underline-focus: {
                    display: none;
                };
                --paper-input-container-underline-disabled: {
                    display: none;
                };
                --paper-input-container-color: none;
                --paper-input-container-focus-color: none;
            }

            a, a:active, a:hover, a:visited {
                text-decoration: none;
                color: var(--cbar-sys-color-secondary, var(--cbar-dark-primary-color, #003F83));
            }

            .body-display-container:not(.encrypted-div) {
                padding: 16px 0;
                height: calc(100% - 62px);
            }

            ::slotted(*) {
                text-align: center;
                padding: 5px;
            }

            header {
                padding: 8px;
            }

            cbar-photo-preview {
                padding: 0;
            }

            h4 {
                margin-top: 0;
            }

            .name-display .time-display{
                margin-left: 4px;
            }

            @media (max-width: 700px){
                .name-display{
                    flex-direction: column;
                }
                .name-display .time-display{
                    margin-left: 0;
                    margin-bottom: 12px
                }
            }
        </style>

        <template is="dom-if" if="[[!hideHeader]]">
            <header style="display: flex; justify-content: space-between; flex-direction: column">
                <h6 style="margin: 4px 0; color: black" hidden$="[[!shouldDisplayName(roomName, hideHeader)]]">[[roomName]]</h6>
                <div style="margin: 4px 0" hidden$="[[!loadingPreviousMessages]]">
                    <div>Loading...</div>
                    <paper-spinner active></paper-spinner>
                </div>
            </header>
        </template>

        <div id="wrapper">
            <template is="dom-if" if="[[__validMessageBoard]]" restamp>
                <template is="dom-if" if="[[__noMessages]]">
                    <div style="color: lightgrey; padding: 8px; display: flex; justify-content: center">Send your message below</div>
                </template>
                <template is="dom-repeat" items="[[messageList]]" as="message">
                    <div class="message-card" data-event="[[message.event_id]]">
                        <div class="card-content">
                            <div class="row">
                                <iron-image src="[[message.userImage]]" sizing="contain" class="avatar"></iron-image>
                                <div class="row-section" style="flex: 1">
                                    <div class="row" style="flex: 1;">
                                        <div style="display: flex" class="name-display">
                                            <strong style="margin-top: 0; margin-bottom: 4px" class="body-text-2">[[message.displayName]]</strong>
                                            <div class="time-display body-text-2">[[message.username]]</div>
                                        </div>
                                        <div class="time-display body-text-2" id="[[message.event_id]]">[[__getDisplayTime(message)]]</div>
                                    </div>
                                    <template is="dom-if" if="[[!message.hasFile]]">
                                        <div class="body-text-2 message-div">[[message.content.body]]</div>
                                    </template>
                                    <template is="dom-if" if="[[message.hasFile]]">
                                        <a href="[[message.file_url]]" target="_blank" class="body-text-2">[[message.content.body]]</a>
                                    </template>
                                    <template is="dom-if" if="[[message.hasImage]]">
                                        <iron-image src="[[message.file_url]]" sizing="cover"
                                            on-tap="handleImageOpening" position="left"></iron-image>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>

            <template is="dom-if" if="[[noRoom]]">
                <div class="body-display-container">
                    <paper-button raised style="margin-top:16px;" on-tap="handleRoomCreation">Start Chat</paper-button>
                </div>
            </template>

            <template is="dom-if" if="[[notPartOfRoom]]">
                <div class="body-display-container">
                    <h6 style="color: #EF5350">No Access</h6>
                    <p style="padding: 8px">You do not have access to this room, please try re-logging into this platform</p>
                </div>
            </template>

            <template is="dom-if" if="[[__roomIsEncrypted]]">
                <div class="body-display-container encrypted-div">
                    <h6 style="color: #EF5350">Encrypted</h6>
                    <p style="padding: 8px">This discussion is encrypted, continue in <a class="chat-continue" href="[[chatUrl]]" target="_blank">[[chatWording]]</a></p>
                </div>
            </template>

            <template is="dom-if" if="[[invalid]]">
                <div class="body-display-container">
                    <h6 style="color: #ffa000">Issue Displaying Room</h6>
                    <p>[[errorMessage]]</p>
                    <paper-button raised style="margin-top:16px;" on-tap="handleConnectionRetry"
                        hidden$="[[!showRetryButton]]">Retry
                    </paper-button>
                </div>
            </template>

            <template is="dom-if" if="[[__displayRoomInvite]]">
                <div class="body-display-container">
                    <h6 style="color: #ffa000">You have been invited!</h6>
                    <p> Please choose whether to join the discussion below.</p>
                    <div>
                        <paper-button raised style="margin-top:16px;" on-tap="handleInvitationRejected">Reject</paper-button>
                        <paper-button raised style="margin-top:16px;" on-tap="handleInvitationAccepted">Accept</paper-button>
                    </div>
                </div>
            </template>

            <template is="dom-if" if="[[loading]]">
                <template is="dom-repeat" items="[[__getRepeatedHtmlArray(4)]]">
                    <div>
                        <div class="card-content">
                            <div class="row">
                                <iron-image class="loading avatar" sizing="cover"></iron-image>
                                <div class="row-section" style="flex: 1">
                                    <div class="row">
                                        <h6 style="margin-top: 0; width: 200px; height: 16px" class="loading"></h6>
                                        <div class="time-display loading" style="width: 34px; height: 16px;"></div>
                                    </div>
                                    <div class="loading loading-message" style="width: 100%; height: 16px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </div>

        <template is="dom-if" if="[[__typingUser]]">
            <div class="typing-div">[[__typingUser]] Is Typing...</div>
        </template>

        <template is="dom-if" if="[[__validMessageBoard]]">
            <div class="message-section">
                <paper-input no-label-float label="Write your message.." name="message" value="{{message}}"
                    on-value-changed="__markAsTyping" on-keyup="__stringKeyUp"
                    disabled$="[[!__validMessageBoard]]"></paper-input>
                <div style="display: flex">
                    <template is="dom-if" if="[[!__isTyping]]">
                        <div>
                            <input type="file" style="position: absolute; height: 40px; opacity: 0; width: 40px; z-index: 1" on-change="handleFileUploaded" disabled$="[[!__validMessageBoard]]">
                            <paper-icon-button disabled$="[[!__validMessageBoard]]" icon="editor:attach-file">
                            </paper-icon-button>
                        </div>
                        <paper-icon-button icon="image:add-a-photo" on-tap="openImageUploader"
                            disabled$="[[!__validMessageBoard]]"></paper-icon-button>
                    </template>
                    <template is="dom-if" if="[[__isTyping]]">
                        <paper-icon-button raised on-tap="__getMessageAndSend" icon="send" type="submit"
                            disabled$="[[!__validMessageBoard]]">Send</paper-button>
                    </template>
                </div>
            </div>
        </template>


        <slot></slot>


        <cbar-photo-preview id="photo-preview" on-navigate-forward="__handleImageChange" on-navigate-back="__handleImageChange"></cbar-photo-preview>
        <cbar-photo-uploader id="photo-upload" on-uploaded-image="handleImageUploaded"></cbar-photo-uploader>
    `;
  }

  static get properties() {
    return {
      /**
       * Room that the user wants the view, is used for receiving and sending messages
       */
      roomId: {
        type: String,
        value: '',
      },
      roomName: {
        type: String,
        value: false
      },
      /**
       * Url of the site holding the API that we want to send pings to
       */
      matrixUrl: {
        type: String,
        value: "https://rooms.communitybuildar.com",
      },
      /*
        sometimes we wish to just use an external client
       */
      existingClient: {
        type: Object,
        value: false
      },
      /**
       * token to authenticate the user that is sending and receiving messages, requires a login call to receive
       */
      accessToken: {
        type: String,
        value: false,
      },
      /**
       * messages that populate the stream
       */
      messageList: {
        type: Array,
        value: [],
      },
      /**
       * user id of that we wish to use as the messaging user
       */
      userId: {
        type: String,
        value: false,
      },
      /**
       * check if the user is currently typing or not
       */
      __isTyping: {
        type: Boolean,
        value: false,
      },
      __lastMessageSender: {
        type: Boolean,
        value: false,
      },
      defaultUserImage: {
        type: String,
        value: "https://cdn.communitybuildar.com/tmp/default.png",
      },
      loading: {
        type: Boolean,
        value: true,
      },
      __validMessageBoard: {
        type: Boolean,
        value: false,
      },
      __isInvitedToRoom: {
        type: Boolean,
        value: false,
      },
      showRetryButton: {
        type: Boolean,
        value: false,
      },
      invalid: {
        type: Boolean,
        value: false,
      },
      errorMessage: {
        type: String,
        value:
          "The room you are trying to access is unavailable, try again later",
      },
      fixed: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      hideHeader: {
        type: Boolean,
        value: false,
      },
      loadingPreviousMessages: {
        type: Boolean,
        value: false
      },
      chatUrl: {
        type: String,
        value : ""
      },
      chatWording : {
        type: String,
        value: "Here"
      },
      displayInvitations: {
        type: Boolean,
        value: false
      }
    };
  }

  static get observers() {
    return [
      "handleLoadingState(loading)",
      "handleInvitationVisable(loading, __isInvitedToRoom)",
      "roomIdChanged(roomId, initialSyncComplete)",
      "startSync(roomId, matrixUrl, accessToken, userId)",
      "validateMessageBoard(loading, invalid, noRoom, notPartOfRoom, __roomIsEncrypted, __isInvitedToRoom)",
      "handleNoMessages(__validMessageBoard, messageList.length)"
    ];
  }

  ready() {
    super.ready();

    this.initialSyncCheck = false;
    this.messages = new Map();
    this.invites = new Map();
    this.__prependMessageCache = [];
    this.__prependFollowUpCache = [];
    this.__invalidRoomChange = false;

    requestAnimationFrame(() => {
      this.messageDiv.addEventListener('scroll', (e) => {
        if(this.messageList.length === 0){
          this.handlingRoomChange = true
          return;
        }

        if(this.handlingRoomChange && this.messageList.length > 0){
          this.handlingRoomChange = false;
          return;
        }

        if (this.messageDiv.scrollTop === 0) {
          this.__loadPreviousMessages();
        }
      })
    })
  }

  get messageDiv() {
    if (!this.__messageDiv) {
      this.__messageDiv = this.root.querySelector("#wrapper");
    }
    return this.__messageDiv;
  }


  get photoPreview() {
    if (!this.__photoPreview) {
      this.__photoPreview = this.root.querySelector("#photo-preview");
    }
    return this.__photoPreview;
  }

  get photoUpload() {
    if (!this.__photoUpload) {
      this.__photoUpload = this.root.querySelector("#photo-upload");
    }
    return this.__photoUpload;
  }

  get messageCards() {
    return Array.from(this.root.querySelectorAll(".message-card"));
  }

  getUserRoom(roomId){
    return this.client.getRoom(roomId);
  }

  checkUserIsInvited(room){
    if(!this.invites){
      return false;
    }

    return room.selfMembership === "invite" || this.invites.has(room.id);
  }

  handleLoadingState(loading){
    if(!loading){
      return;
    }

    this.messageList = [];
    this.roomName = '';
    this.notPartOfRoom = false;

    this.__previousMessage = false;
    this.__isInvitedToRoom = false;
    this.__roomIsEncrypted = false;
    this.__loadedImages = [];
  }

  handleInvitationVisable(loading, __isInvitedToRoom){
    this.__displayRoomInvite = !loading && __isInvitedToRoom;
  }

  roomIdChanged(roomId, initialSyncComplete) {
    if (!initialSyncComplete || this.__invalidRoomChange) {
      return;
    }

    this.loading = true;

    if (!roomId) {
      this.__handleNoRoom();

      return;
    }

    if (roomId.indexOf('!') !== 0) {
      this.__invalidRoomChange = true;
      this.roomId = '!' + roomId;
      this.__invalidRoomChange = false;

      return;
    }

    // Note: this does not call the API again, it just uses
    // the rooms from the sync
    let room = this.getUserRoom(roomId);

    if(!room){
      this.notPartOfRoom = true;
      this.loading = false;
      return;
    }

    // invited rooms return, however there will an associated invitation alongside
    // the room will not contain messages until the invitation is accepted and permissions are granted
    this.__isInvitedToRoom = this.checkUserIsInvited(room);

    // Set room name
    this.roomName = room.name;

    // If we've got stored messages, display them
    if (this.messages.has(roomId)) {
      const messages = this.messages.get(roomId);

      // Need to wait an animation frame between each message, as
      // the message div must be rendered in case we're appending a message from
      // the same sender to it
      messages.forEach(message =>
        requestAnimationFrame(() => this._addMessage(message)));
    } else {
      this.loading = true;

      let room = this.getUserRoom(this.roomId);

      if(!room){
        return;
      }

      room.timeline.forEach(event => {
        this.__handleMessage(event, room);
      });
    }

    this.loading = false;
  }

  async startSync(roomId, matrixUrl, accessToken, userId) {
    if (!roomId && matrixUrl && accessToken) {
      this.__handleNoRoom();
      return;
    }

    if (!roomId || !matrixUrl || !accessToken || !userId) {
      return;
    }

    this.loading = true;

    this.set("noRoom", false);

    if(!this.client) {
      if(typeof matrixcs === 'undefined'){
        await import('@cbar/cbar-chat-client/browser-matrix.min.js');
      }

      this.client = this.existingClient ? this.existingClient : matrixcs.createClient({
        baseUrl: matrixUrl,
        accessToken: this.accessToken,
        userId: this.userId,
      });
    }

    this.client.on("RoomMember.typing", (event, member) => {
      if (
        member.userId === this.userId ||
        member.roomId !== this.roomId
      ) {
        return;
      }

      this.__typingUser = member.typing ? member.name : null;
    });

    this.client.on("RoomMember.membership", (event, member) => {
      if (member.userId !== this.userId) {
        return;
      }

      if (member.membership === "invite") {
        this.invites.set(event.event.room_id);
      }

      if (member.membership === "join") {
        this.invites.delete(event.event.room_id);
      }
    });

    this.client.on("Room.timeline", (event, room, toStartOfTimeline) => {
      if (toStartOfTimeline) {
        return; // don't print paginated results
      }

      this.__handleMessage(event, room)
    });

    this.client.on('sync', () => {
      this.initialSyncComplete = true;
      this.loading = false;
    });

    if(!this.existingClient) {
      this.client.startClient({initialSyncLimit: 30});
      return;
    }

    if(this.existingClient && this.client){

      let room = this.getUserRoom(this.roomId);

      if(!room){
        return;
      }

      this.__isInvitedToRoom = this.checkUserIsInvited(room);

      room.timeline.forEach(event => {
        this.__handleMessage(event, room);
      });

      requestAnimationFrame(() => {
        this.loading = false;
        this.initialSyncComplete = true;
      });
    }
  }

  _storeMessage(roomId, message, prepending) {
    if(!this.messages){
      this.messages = new Map;
    }

    if (!this.messages.has(roomId)) {
      this.messages.set(roomId, []);
    }

    const roomMessages = this.messages.get(roomId);

    if(!prepending){
      roomMessages.push(message);
    }

    if (this.roomId === message.room_id) {
      this._addMessage(message, prepending);
    }
  }

  _addMessage(message, prepending = false) {
    let messageToFollowUp = this.__previousMessage;
    let isFollowupMessage = this.__messageFromSameSender(message);


    if(this.__checkForExistingMessage(message)){
      return;
    }

    if(message.hasImage){
      this.__handleImageAttachment(message.file_url);
    }

    if (!prepending && isFollowupMessage) {
      // its the same here, instead of creating a new message for the list, append a section to the previous message
      this.__appendMessageToPreviousCard(message);
    } else {

      let sender = message.user_id ? message.user_id : message.sender;

      // isnt the same sender, add a new message block
      message.userImage = this.__getUserImage(message.senderObject);

      message.username = sender.split(':auth')[0];

      if(prepending){
        // if we are prepending a list of new messages, we need to save all to work with binding function "unshift"
        this.cacheToPrependArray(message, isFollowupMessage, messageToFollowUp);
        return;
      }

      let string = message.content.formatted_body ? message.content.formatted_body : message.content.body;
      message.content[message.content.formatted_body ? 'formatted_body' : 'body'] = this.__formatUrlString(string);

      this.push("messageList", message);

      // let the div render
      requestAnimationFrame(() => {
        let targetCard = this.messageCards.find(card => card.dataEvent === message.event_id);

        if(!targetCard) {
          return;
        }

        let divToFormat = targetCard.querySelector('.message-div');

        if(divToFormat) {
          divToFormat.innerHTML = divToFormat.innerText;
        }
      })
    }

    // scroll the div to the bottom when a new message happens
    requestAnimationFrame(() => {
      if(!prepending) {
        this.scrollToBottom();
      }
    });
  }

  /**
   * sends our message to the room
   * @param body
   * @private
   */
  __sendMessage(body) {
    this.client.sendTextMessage(this.roomId, body, "", () => {
    });
  }

  /**
   * when we press enter in the input, the only logical action it can perform is submit the text box, so lets do so
   * @param e
   * @private
   */
  __stringKeyUp(e) {
    if (e.key === "Enter") {
      this.__getMessageAndSend();
    }
  }

  /**
   * grabs the message wanting to be sent, and passes that to the send message
   * function
   * @private
   */
  __getMessageAndSend() {
    let input = this.root.querySelector("paper-input");
    let message = this.message;

    // dont let people spam empty string messages
    if (message.trim() !== "") {
      this.__sendMessage(message);
    }

    input.value = "";
  }

  /**
   * checks whether you are currently typing or not and sets your status to everyone else in the room
   * @param e
   * @private
   */
  __markAsTyping(e) {
    // check the that the state of us typing has changed
    let value = e.detail.value;
    let isStillTyping = this.__isTyping && value !== "";
    let hasntTyped = !this.__isTyping && value === "";

    // if the status of us typing hasn't changed, then return
    if (hasntTyped || isStillTyping) {
      return;
    }

    this.__isTyping = value !== "";

    this.client.sendTyping(this.roomId, this.__isTyping, 2000);
  }

  /**
   * this function formats whether the next message should display in conjunction with the previous.
   * this depends on 2 parameters, whether the message is coming from the same sender as the last
   * and how long ago the last message was sent
   * @param message
   * @return {boolean}
   * @private
   */
  __messageFromSameSender(message) {
    // if theres no previous message to check, then dont worry
    if (!this.__previousMessage) {
      // handle the inital message here
      this.__previousMessage = message;
      return false;
    }

    // if the message is older than 10 minutes, we need to create a new block, so return false
    if (this.__messageOld(this.__previousMessage.origin_server_ts, message.origin_server_ts)) {
      this.__previousMessage = message;
      return false;
    }


    // if the message is from the same sender, return true here
    if (message.sender === this.__previousMessage.sender) {
      this.__previousMessage = message;
      return true;
    }

    // by default return false
    this.__previousMessage = message;
    return false;
  }

  /**
   * adds the new message to the previous card to group messages by recent users
   * @param message
   * @param index
   * @private
   */
  __appendMessageToPreviousCard(message) {
    const index = this.messageCards.length;

    // no cards
    if (index === 0) {
      return;
    }

    // create a div for our new message to sit in
    let targetCard = message.appending ? this.messageCards.find(card => card.dataEvent === message.appending) : this.messageCards[index-1];

    if(!targetCard){
      let divsToCheck = Array.from(this.root.querySelectorAll('.message-content'));
      let appendingDiv = divsToCheck.find(div => div.dataMessageEvent === message.appending);

      if(!appendingDiv){
        return;
      }

      targetCard = appendingDiv.parentElement.parentElement;
    }

    let divToAppend = targetCard.children[0];

    if(!divToAppend){
      return;
    }

    if (message.hasFile) {
      this.__appendFileToPreviousCard(message.content.body, message.file_url, divToAppend, message);
      return;
    }

    let elementToAdd = document.createElement("DIV");
    elementToAdd.classList.add("message-content");
    elementToAdd.classList.add('body-text-2');

    elementToAdd.dataEvent = divToAppend.parentNode.dataEvent;
    elementToAdd.dataMessageEvent = message.event_id;

    elementToAdd.innerHTML = message.content.formatted_body ? this.__formatUrlString(message.content.formatted_body) : this.__formatUrlString(message.content.body);
    // give it some room
    elementToAdd.style.marginTop = "8px";

    // and append it
    divToAppend.appendChild(elementToAdd);

    if (message.hasImage) {
      this.__appendImageToPreviousCard(message.file_url, divToAppend);
    }

  }

  __appendImageToPreviousCard(imageUrl, divToAppend) {
    let elementToAdd = document.createElement("iron-image");
    elementToAdd.src = imageUrl;
    elementToAdd.classList.add("message-content");
    elementToAdd.sizing = "contain";
    elementToAdd.position = "left";
    elementToAdd.dataEvent = divToAppend.parentNode.dataEvent;

    elementToAdd.addEventListener("tap", (e) => {
      this.handleImageOpening(e);
    });

    divToAppend.appendChild(elementToAdd);
  }

  __appendFileToPreviousCard(fileText, fileUrl, divToAppend, event) {
    let elementToAdd = document.createElement("a");

    elementToAdd.href = `javascript:window.open('${fileUrl}')`;
    elementToAdd.innerHTML = fileText;
    elementToAdd.dataEvent = divToAppend.parentNode.dataEvent;
    elementToAdd.dataMessageEvent = event.event_id;
    elementToAdd.classList.add("message-content");
    elementToAdd.classList.add('body-text-2');
    elementToAdd.style.marginTop = "8px";

    divToAppend.appendChild(elementToAdd);
  }

  /**
   * checks if the new message is 10 minutes old or longer
   * @param oldMessageTimestamp
   * @param newMessageTimestamp
   * @return {boolean}
   * @private
   */
  __messageOld(oldMessageTimestamp, newMessageTimestamp) {
    // checks how many minutes between the timestamps, then checks to see if its 10 minutes or longer
    return (newMessageTimestamp - oldMessageTimestamp) / 1000 / 60 > 9;
  }

  /**
   * converts timestamp to display date
   * @param messageTime
   * @private
   */
  __getDisplayTime(message) {
    let dateObj = dayjs(message.origin_server_ts);
    let isYesterday = dateObj.isBefore(dayjs(), 'day');
    let isLastYear = dateObj.isBefore(dayjs(), 'year');

    let dateString = "";

    if(isYesterday){
      dateString += ` ${dateObj.format('D MMM ')} `;
    }

    if(isLastYear){
      dateString += ` ${dateObj.format(' YY ')} `;
    }

    return dateString + ` ${dateObj.hour()}:${
      (dateObj.minute() < 10 ? "0" : "") + dateObj.minute()
    }`;
  }

  __getUserImage(sender) {
    let senderInformation = sender.events.member.event.content;

    return senderInformation.avatar_url
      ? this.client.mxcUrlToHttp(senderInformation.avatar_url)
      : this.defaultUserImage;
  }

  __getRepeatedHtmlArray(number) {
    return Array(number);
  }

  __handleNoRoom() {
    this.loading = false;
    this.noRoom = true;
  }

  validateMessageBoard(loading, invalid, noRoom, notPartOfRoom, __roomIsEncrypted, __isInvitedToRoom) {
    if (loading) {
      this.noRoom = false;
    }

    this.set("__validMessageBoard", !this.loading && !invalid && !noRoom && !notPartOfRoom && !__roomIsEncrypted && !__isInvitedToRoom);
  }

  handleNoMessages(__validMessageBoard, messageListLength){
    this.__noMessages = __validMessageBoard && messageListLength === 0;
  }

  handleRoomCreation() {
    this.dispatchEvent(
      new CustomEvent("room-toggled", {
        bubbles: true,
        composed: true,
      })
    );
  }

  handleConnectionRetry() {
    this.invalid = false;
    this.loading = true;
    this.dispatchEvent(
      new CustomEvent("retry-connection", {
        bubbles: true,
        composed: true,
      })
    );
  }

  handleInvitationRejected(){
    this.__isInvitedToRoom = false;
    this.client.leave(this.roomId);

    this.dispatchEvent(new CustomEvent('room-left', {
      bubbles: true,
      composed: true,
      detail: {
        value: this.roomId
      }
    }));

    this.roomId = false;
  }

  handleInvitationAccepted() {
    this.__isInvitedToRoom = false;
    this.client.joinRoom(this.roomId);
    this.invites.delete(this.roomId);
  }

  __handleFileAddition(event) {
    let fileType = event.content.msgtype;

    if (fileType !== "m.image" && fileType !== "m.file") {
      return null;
    }

    let eventInformation = event.content;

    let imageSize = eventInformation.info.size;

    event.content.body += this.__calculateImageSize(imageSize);

    let fileWidth = fileType === "m.image" ? eventInformation.info.w : null;
    let fileHeight = fileType === "m.image" ? eventInformation.info.h : null;
    let resizeMethod = fileType === "m.image" ? "scale" : "";

    if (event.content.msgtype === "m.file") {
      event.content.body =  event.content.body;
    }

    return this.client.mxcUrlToHttp(
      eventInformation.url,
      fileWidth,
      fileHeight,
      resizeMethod,
      true
    );
  }

  handleImageOpening(e) {
    let image = e.target.src;

    this.photoPreview.image = image;
    requestAnimationFrame(() => {
      this.photoPreview.toggle();
    });
  }

  __calculateImageSize(sizeInBytes) {
    if (sizeInBytes > 1000) {
      let amount = sizeInBytes > 1000000 ? 1000000 : 1000;
      let division = sizeInBytes > 1000000 ? "MB" : "KB";

      let value = Math.round((sizeInBytes / amount) * 100) / 100;
      return ` (${value} ${division})`;
    }

    return ` (${sizeInBytes}B)`;
  }

  openImageUploader() {
    this.photoUpload.open = false;
    requestAnimationFrame(() => {
      this.photoUpload.initialCropArea = 1;
      this.photoUpload.open = true;
    });
  }

  async handleImageUploaded(e) {
    e.preventDefault();
    let details = e.detail;

    let imageBlob = await this.getBlob(details.croppedCanvas);
    let mxcFileUrl = {};

    try {
      mxcFileUrl = await this.client.uploadContent(imageBlob, {
        name: details.imageName,
      });

      if(!mxcFileUrl || (typeof mxcFileUrl === "object" && !mxcFileUrl.content_uri)){
        throw Error('Issue with file upload');
      }
    }catch(e){
      if(e instanceof DOMException){
        this.photoUpload.errorMessage = "Image File Too Large";
      } else {
        this.photoUpload.errorMessage = "Issue uploading image, please try again later";
      }

      this.photoUpload.__loading = false;
      return;
    }

    let imageInfo = {
      w: details.croppedCanvas.width,
      h: details.croppedCanvas.height,
      thumbnail_url: mxcFileUrl.content_uri ? mxcFileUrl.content_uri : mxcFileUrl,
      size: imageBlob.size,
      thumbnail_info: {
        w: details.croppedCanvas.width,
        h: details.croppedCanvas.height,
        size: imageBlob.size,
      },
    };

    this.uploadImage(
      mxcFileUrl.content_uri ? mxcFileUrl.content_uri : mxcFileUrl,
      imageInfo,
      details.imageName
    );
  }

  getBlob(canvas) {
    return new Promise((res, rej) => {
      canvas.toBlob((blob) => res(blob));
    });
  }

  async uploadImage(fileUrl, imageInfo, fileName) {
    const content = {
      msgtype: 'm.image',
      url: fileUrl,
      info: imageInfo,
      body: fileName,
    };

    await this.client.sendMessage(
      this.roomId,
      null,
      content,
    );

    this.photoUpload.open = false;
    this.photoUpload.__loading = false;
  }

  __checkAttachmentType(event) {
    let fileType = event.content.msgtype;

    event.hasImage = false;
    event.hasFile = false;

    if (fileType !== "m.image" && fileType !== "m.file") {
      return;
    }

    if (fileType === "m.image") {
      event.hasImage = true;
    }

    if (fileType === "m.file") {
      event.hasFile = true;
    }
  }

  handleFileUploaded(e) {
    let target = e.target;
    let files = target.files;

    if (!files || files.length === 0) {
      return;
    }

    // strip this object key so we can accurately create an array of all objects
    delete files.length;
    Object.keys(files).forEach(async (entry) => {
      let file = files[entry];

      let result = await this.client.uploadContent(file, {
        name: file.name,
      });

      if(!result || (typeof result === "object" && !result.content_uri)){
        throw Error('Issue with file upload');
      }

      let messageInformation = {
        body: file.name,
        info: {size: file.size, mimetype: file.type},
        msgtype: "m.file",
        url: result.content_uri ? result.content_uri : result,
      };

      await this.client.sendMessage(
        this.roomId,
        messageInformation,
        "",
        () => {
        }
      );
    });
  }

  scrollToBottom() {
    this.messageDiv.scrollTop = this.messageDiv.scrollHeight;
  }

  __handleMessage(event, room, prepending = false){
    if(this.roomId && this.roomId === room.roomId && event.getType() === "m.room.encrypted"){
      if(this.messageList.length === 0) {
        //TODO: work
        this.__roomIsEncrypted = true;
      }

      if(prepending){
        this.__messagesToPrepend--;
      }
      return;
    }

    if (event.getType() !== "m.room.message") {
      let skipOver = true;
      if(event.getType() === "m.room.member" && this.displayInvitations){
        event = this.__formatMembershipMessage(event);
        skipOver = false;
      }

      if(skipOver) {
        if(prepending){
          this.__messagesToPrepend--;
        }

        return; // only print messages
      }
    }

    const message = event.event;

    if (room.roomId === this.roomId) {
      this.roomName = room.name;
    }

    if (message.unsigned && message.unsigned.redacted_by) {
      // we dont want message that have been deleted showing
      if(prepending){
        this.__messagesToPrepend--;
      }
      return;
    }

    let sender = event.sender;

    message.senderObject = sender;

    requestAnimationFrame(() => {
      message.displayName = sender.rawDisplayName;

      this.__checkAttachmentType(message);

      message.file_url = this.__handleFileAddition(message);

      this._storeMessage(room.roomId, message, prepending);
    });
  }

  shouldDisplayName(roomName ,hideHeader){
    return roomName && !hideHeader;
  }

  async __loadPreviousMessages(){
    let messages = [...this.messageList];
    let newestMessage = messages[0];

    let room = this.getUserRoom(this.roomId);
    this.loadingPreviousMessages = true;
    let updateRoomState = await this.client.scrollback(room, 30);
    let messagesToPrepend = [];

    updateRoomState.timeline.forEach((event) => {
      if (event.getType() !== "m.room.message") {
        let skipOver = true;

        if(event.getType() === "m.room.member" && this.displayInvitations){
          event = this.__formatMembershipMessage(event);
          skipOver = false;
        }

        if(skipOver) {
          return; // only print messages
        }
      }

      // we need to handle message deduplication here, so lets do that
      if(this.__checkForExistingMessage(event.event)){
        return;
      }

      messagesToPrepend.push(event);
    });

    this.__prependMessages(messagesToPrepend);

    requestAnimationFrame(() => {
      let filteredCards = [...this.messageCards].filter(card => card.dataEvent === newestMessage.event_id);
      this.messageDiv.scrollTop = filteredCards[0].offsetTop - 32
    });
  }

  __prependMessages(events){
    this.__previousMessage = null;
    this.__messagesToPrepend = events.length;
    this.__prependMessageCache = [];
    this.__prependFollowUpCache = [];
    this.__allPrependMessages = [];

    events.forEach((event, i) => {
      this.__handleMessage(event, this.getUserRoom(this.roomId), true)
    });

    this.loadingPreviousMessages = false;
  }

  cacheToPrependArray(message, isFollowUpMessage, messageToFollowUp){
    this.__allPrependMessages.push(message);
    if(isFollowUpMessage){
      // we have to get someway to identify what message we need to append this to later down the track
      // so we need to append this here
      this.__prependFollowUpCache.push({
        appending: messageToFollowUp.event_id,
        ...message
      });

      this.__messagesToPrepend--;

      if(this.__prependMessageCache.length !== this.__messagesToPrepend) {
        return;
      }
    } else {
      this.__prependMessageCache.push(message);
    }

    // once we have all the required messages formatted and ready to go, we update the visual component here
    if(this.__prependMessageCache.length === this.__messagesToPrepend){
      // we add all of the standard message list information here with the saved data
      this.unshift('messageList', ...this.__prependMessageCache);

      requestAnimationFrame(() => {
        this.__ensureMessages();
        // then we reset previous "appended messages" to their desired spot
        //TODO: re-do this, there might be a way to take advantage of bindings to handle this
        this.__calculateAppendedMessages();

        // we need to then add any "appended messages" to the new cards
        this.__prependFollowUpCache.forEach(message => {
          this.__appendMessageToPreviousCard(message);
        })

        const messages = this.messages.get(this.roomId);
        messages.unshift(...this.__allPrependMessages);

        // we make sure here that we scroll down so users can re-fire the functionality
        this.messageDiv.scrollBy(0, 100);
      })
    }
  }

  __calculateAppendedMessages(){
    // grab all of our existing "appended messages"
    let divsToMove = Array.from(this.root.querySelectorAll('.message-content'));

    divsToMove.forEach(div => {
      // clone the div with all of its information
      let newDiv = div.cloneNode(true);

      // copy over the dataset info (requried for validation checks)
      newDiv.dataEvent = div.dataEvent;
      newDiv.dataMessageEvent = div.dataMessageEvent;

      if(div.src){
        // handling images
        newDiv.src = div.src
        newDiv.position = 'left'
      }

      // find the desired spot to place it back
      let target = this.messageCards.find(card => card.dataEvent === div.dataEvent);

      if(!target){
        return;
      }

      let targetLocation = target.children[0];

      // add clone to the desired spot here, and then we remove the old one
      targetLocation.appendChild(newDiv);

      div.remove();
    });
  }

  __checkForExistingMessage(event){
    if(this.messageList.find(message => message.event_id === event.event_id)){
      // message already in list
      return true;
    }

    let divsToCheck = Array.from(this.root.querySelectorAll('.message-content'));

    if(divsToCheck.find(div => div.dataMessageEvent === event.event_id)){
      // message is in a follow up message we dont want to duplicate
      return true;
    }

    return false;
  }

  __formatUrlString(string){
    let urlStrings = this.__getStringUrls(string);

    if(urlStrings.length === 0){
      return string;
    }

    let stringsToReplace = [];
    urlStrings.forEach(url => {
      if(!stringsToReplace.includes(url)) {
        stringsToReplace.push(url);
      }
    });

    stringsToReplace.forEach(urlToEdit => {
      string = string.replaceAll(urlToEdit, `<a href='javascript:window.open("${urlToEdit}")'>${urlToEdit}</a>`);
    });

    return string;
  }

  __getStringUrls(string){
    // return all the substrings within our string
    return [...string.matchAll(this.__getUrlRegex())].map(returnIndex => {
      return returnIndex[0]
    });
  }

  __getUrlRegex(){
    // valid url regex: https://stackoverflow.com/questions/1315653/regular-expression-to-find-urls-not-inside-a-hyperlink
    return new RegExp(/(?!<a[^>]*>[^<])(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?))(?![^<]*<\/a>)/, 'g');
  }

  // we want to display the status of invitations, so lets do that here
  __formatMembershipMessage(event){
    let message = event.event;
    let inviter = event.sender.name;

    event.event.content.body = `${inviter} ${this.__getInvitationStatus(event)}`;

    return event;
  }

  __getInvitationStatus(event){
    let statusMap = {
      join: 'accepted and joined',
      leave: 'rejected the invitation',
      invite: `invited ${event.event.content.displayname ? event.event.content.displayname : event.event.state_key}`
    };

    return statusMap[event.event.content.membership];
  }

  // stupid hack because unshift doesnt restamp correctly, thanks google
  __ensureMessages(){
    this.messageList.forEach((message) => {
      let targetCard = this.messageCards.find(card => card.dataEvent === message.event_id);
      let divToFormat = null;

      // message div doesnt exist for file upload messages, so we need to add this check here
      if(message.content.msgtype === "m.file"){
        divToFormat = targetCard.querySelector('a');
        divToFormat.href = message.file_url;
      } else {
        divToFormat = targetCard.querySelector('.message-div');
      }

      divToFormat.innerHTML = message.content.body;
    });
  }

  __handleImageAttachment(imageUrl){
    if(!this.__loadedImages){
      this.__loadedImages = [];
    }

    if(this.__loadedImages.includes(imageUrl)){
      return;
    }

    this.__loadedImages.push(imageUrl);
  }

  __handleImageChange(e){
    let indexChange = e.type === "navigate-forward" ? 1 : -1;
    let currentImage = this.photoPreview.image;

    let indexOfCurrentImage = this.__loadedImages.indexOf(currentImage);

    if(this.__loadedImages[indexOfCurrentImage+indexChange]){
      this.photoPreview.image = this.__loadedImages[indexOfCurrentImage+indexChange];
    }
  }
}

window.customElements.define("cbar-chat-client", CbarChatClient);
